import React from "react";
import { useTranslation } from "react-i18next";
import {
  AssetItem,
  AssetItemName,
  AssetItemPrice,
} from "../../../../AssetListScreenStyles";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { GeneralProject } from "../../../../../../../../interface/Server";
import { CarouselWrapper } from "../../../../../../Widget/Carousel";
import { getDisplayName } from "./AssetListItem";

interface Props {
  item: GeneralProject;
  nameplateDisplay?: boolean;
  hideButton?: boolean;
  onSelectProject?: (project: GeneralProject) => void;
  amount?: number;
  isMobile?: boolean;
}

const GeneralProjectItem: React.FunctionComponent<Props> = (props) => {
  const { description, images, projectId, projectName, projectNameZH } =
    props.item;
  const { t, i18n } = useTranslation();
  const useChi = i18n.language === "zhTW" || i18n.language === "cn";
  console.log("GeneralProjectItem");
  let displayName = getDisplayName(i18n.language, projectName, projectNameZH);
  return (
    <>
      <AssetItem key={projectId}>
        <Row style={{ margin: 0, padding: 0, display: "flex" }}>
          <div
            style={{
              width: "220px",
              height: "147px",
            }}
          >
            <CarouselWrapper images={images} />
          </div>
          <div
            style={{
              flex: 2,
              display: "flex",
              flexDirection: "column",
              ...(!props.nameplateDisplay
                ? { padding: "20px" }
                : { paddingLeft: "20px" }),
            }}
          >
            {!props.nameplateDisplay ? (
              <div style={{ flex: 1 }}>
                <AssetItemName
                  isChinese={useChi}
                >{`${displayName}`}</AssetItemName>
                {description && (
                  <AssetItemName
                    location
                    isChinese={useChi}
                  >{`${description}`}</AssetItemName>
                )}
                <AssetItemName
                  isChinese={useChi}
                  style={{ fontSize: 12, color: "#5F929B" }}
                >
                  - {t("virtualPlaqueNote")}
                </AssetItemName>
              </div>
            ) : (
              <>
                <div style={{ flex: 1 }}>
                  <AssetItemPrice
                    isChinese={useChi}
                  >{`${displayName}`}</AssetItemPrice>
                  {description && (
                    <AssetItemPrice
                      isChinese={useChi}
                      location
                    >{`${description}`}</AssetItemPrice>
                  )}
                </div>
              </>
            )}
            {props.isMobile && !props.hideButton && (
              <Button
                onClick={() => {
                  props.onSelectProject && props.onSelectProject(props.item);
                }}
                variant={"primary"}
                style={{
                  backgroundColor: "#2c3e50",
                  borderColor: "#2c3e50",
                  width: "90%",
                  fontFamily: "Rambla",
                  ...(useChi
                    ? { fontFamily: "Microsoft JhengHei" }
                    : { fontFamily: "Rambla" }),
                }}
              >
                {t("select")}
              </Button>
            )}
          </div>
          {!props.isMobile && (!props.hideButton || props.amount) && (
            <div
              style={{
                minWidth: "150px",
                display: "flex",
                flexDirection: "column",
                justifyContent: props.amount ? "space-between" : "flex-end",
                borderLeftStyle: "solid",
                borderColor: "#d4d8d8",
                borderLeftWidth: "1px",
                padding: "0px 8px",
                margin: "8px 0px",
              }}
            >
              {!!props.amount && (
                <AssetItemPrice>
                  HK${props.amount.toLocaleString()}
                </AssetItemPrice>
              )}
              {!props.hideButton && (
                <Button
                  onClick={() => {
                    props.onSelectProject && props.onSelectProject(props.item);
                  }}
                  variant={"primary"}
                  style={{
                    backgroundColor: "#2c3e50",
                    borderColor: "#2c3e50",
                    width: "90%",
                    fontFamily: "Rambla",
                    ...(useChi
                      ? { fontFamily: "Microsoft JhengHei" }
                      : { fontFamily: "Rambla" }),
                  }}
                >
                  {t("select")}
                </Button>
              )}
            </div>
          )}
        </Row>
      </AssetItem>
    </>
  );
};

GeneralProjectItem.defaultProps = {
  onSelectProject: () => {},
  hideButton: false,
  amount: undefined,
};

export default GeneralProjectItem;
